import { render, staticRenderFns } from "./SmsFrstCertn.vue?vue&type=template&id=452da37b&scoped=true"
import script from "./SmsFrstCertn.vue?vue&type=script&lang=js"
export * from "./SmsFrstCertn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452da37b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('452da37b')) {
      api.createRecord('452da37b', component.options)
    } else {
      api.reload('452da37b', component.options)
    }
    module.hot.accept("./SmsFrstCertn.vue?vue&type=template&id=452da37b&scoped=true", function () {
      api.rerender('452da37b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/auth/SmsFrstCertn.vue"
export default component.exports